/**
 * 작업 지시서 관련 검증 유틸리티
 */
export class ValidationUtils {
  
  /**
   * Step1 - 거래처 선택 검증
   */
  static validateStep1(selectedClient) {
    if (!selectedClient) {
      return {
        isValid: false,
        message: '거래처를 선택해주세요.'
      };
    }
    return { isValid: true };
  }

  /**
   * Step2 - 환자 정보 검증
   */
  static async validateStep2(step2Ref) {
    if (!step2Ref) {
      return {
        isValid: false,
        message: 'Step2 컴포넌트를 찾을 수 없습니다.'
      };
    }

    const isValid = await step2Ref.validateForm();
    return {
      isValid,
      message: isValid ? '' : '환자 정보를 올바르게 입력해주세요.'
    };
  }

  /**
   * Step3 - 상세 정보 검증
   */
  static async validateStep3(step3Ref) {
    if (!step3Ref) {
      return {
        isValid: false,
        message: 'Step3 컴포넌트를 찾을 수 없습니다.'
      };
    }

    const isValid = await step3Ref.validateForm();
    return {
      isValid,
      message: isValid ? '' : '상세 정보를 올바르게 입력해주세요.'
    };
  }

  /**
   * 최종 데이터 검증
   */
  static validateFinalData(selectedClient, certificateInfo, workOrderData) {
    const errors = [];

    if (!selectedClient) {
      errors.push('거래처 정보가 없습니다.');
    }

    if (!certificateInfo || !certificateInfo.name) {
      errors.push('환자 정보가 불완전합니다.');
    }

    if (!workOrderData || !workOrderData.selectedTeeth || workOrderData.selectedTeeth.length === 0) {
      errors.push('치아 선택 정보가 없습니다.');
    }

    return {
      isValid: errors.length === 0,
      errors
    };
  }
}
